import React, { useState } from "react";
import api from "@/lib/api";
import { Sparkles, PlayCircle, ShieldCheck, Home as HomeIcon, LayoutDashboard } from "lucide-react";

const SHOWROOM_ENVIRONMENTS = [
    {
        id: "user_demo_seed",
        name: "Studio VendiDirect",
        email: "demo@vendidirect.it",
        description: "Profilo agenzia dimostrativo completo: annunci, lead, pipeline CRM e VD Manager già popolati per presentazioni live.",
    },
    // Futuri ambienti demo (es. profilo privato, profilo agenzia estera) potranno essere
    // aggiunti qui seguendo lo stesso schema {id, name, email, description}.
];

export default function AdminShowroom() {
    const [busyId, setBusyId] = useState(null);
    const [error, setError] = useState("");

    const launch = async (env) => {
        setBusyId(env.id); setError("");
        try {
            await api.post(`/admin/impersonate/${env.id}`);
            window.location.href = "/dashboard";
        } catch (e) {
            setError(e?.response?.data?.detail || "Errore avvio demo");
            setBusyId(null);
        }
    };

    return (
        <div data-testid="admin-showroom-tab">
            <div className="mb-6">
                <span className="label-eyebrow text-gold">Super-Admin</span>
                <h2 className="font-serif text-2xl text-ink-50 mt-2 flex items-center gap-2">
                    <Sparkles size={20} className="text-gold" /> VendiDirect Showroom
                </h2>
                <p className="text-ink-400 text-sm mt-1">
                    Ambienti demo isolati e protetti, con dati sempre pronti e funzionalità premium sbloccate, per mostrare la piattaforma a prospect e partner senza toccare i dati reali.
                </p>
            </div>

            {error && <div className="mb-4 p-3 border border-red-500/40 bg-red-900/20 text-red-200 text-xs" data-testid="showroom-error">{error}</div>}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {SHOWROOM_ENVIRONMENTS.map((env) => (
                    <div key={env.id} data-testid={`showroom-env-${env.id}`} className="border border-gold/30 bg-gold/5 p-6 flex flex-col">
                        <div className="flex items-center gap-2 text-[11px] uppercase tracking-wider text-gold mb-3">
                            <ShieldCheck size={13} /> Ambiente protetto
                        </div>
                        <h3 className="font-serif text-xl text-ink-50">{env.name}</h3>
                        <p className="text-xs text-ink-500 mt-0.5">{env.email}</p>
                        <p className="text-sm text-ink-400 mt-3 leading-relaxed flex-1">{env.description}</p>
                        <div className="flex items-center gap-3 mt-5 text-[11px] text-ink-500">
                            <span className="flex items-center gap-1"><LayoutDashboard size={12} /> Dashboard</span>
                            <span className="flex items-center gap-1"><HomeIcon size={12} /> VD Manager</span>
                        </div>
                        <button
                            data-testid={`showroom-launch-${env.id}`}
                            onClick={() => launch(env)}
                            disabled={busyId === env.id}
                            className="cta-gold mt-5 w-full py-3 text-sm font-medium flex items-center justify-center gap-2 disabled:opacity-50"
                        >
                            <PlayCircle size={15} /> {busyId === env.id ? "Avvio…" : "Lancia Demo"}
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
}
